import React, { useEffect, useState } from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useWatch } from 'react-hook-form';

export default function Disabled(
  elements: FormComponent | FormComponent[],
  params?: {
    watchOn?: string | string[] | ((parentName: string) => string | string[]);
    callback?: (watchValues: any) => boolean;
  }
): FormComponent {
  return ({ ...rest }) => (
    <DisabledComponent
      elements={Array.isArray(elements) ? elements : [elements]}
      watchOn={params?.watchOn}
      callback={params?.callback}
      watchOnPrefix={{ ...rest }.parentName}
      {...rest}
    />
  );
}

export function DisabledComponent({
  elements,
  watchOn,
  callback,
  watchOnPrefix,
  ...rest
}: FormComponentProps & {
  elements: FormComponent[];
  watchOn?: any;
  callback?: (watchValues: any) => boolean;
  watchOnPrefix?: string;
}) {
  if (watchOn && watchOnPrefix) {
    watchOn =
      typeof watchOn === 'function' ? watchOn(rest.parentName) : watchOn;
    switch (true) {
      case watchOn.startsWith('/'):
        watchOn = watchOn.substring(1);
        break;
      case watchOn.startsWith('_'):
        watchOn = watchOn
          .substring(1)
          .replace(/__(\d+)__/g, (match: any, index: any) => {
            return '.' + watchOnPrefix.split('.')[index] + '.';
          });
        break;
      default:
        watchOn = `${watchOnPrefix}.${watchOn}`;
        break;
    }
  }

  const watchValues = useWatch({ name: watchOn });

  const [disabledValue, setDisabledValue] = useState(true);
  useEffect(() => {
    if (watchOn) {
      if (callback) {
        Promise.resolve(callback(watchValues)).then((value) =>
          setDisabledValue(value)
        );
      } else {
        if (Array.isArray(watchValues)) {
          setDisabledValue(!watchValues.filter(Boolean));
        } else {
          setDisabledValue(!watchValues);
        }
      }
    }
  }, [watchOn, watchValues, callback]);

  return (
    <>
      {elements.map((Element, index) => {
        return <Element key={index} disabled={disabledValue} {...rest} />;
      })}
    </>
  );
}
